import { createFileRoute, redirect } from "@tanstack/react-router";

/** Permanent redirect stub — see services.tsx. */
export const Route = createFileRoute("/_public/services/$slug")({
  beforeLoad: () => {
    throw redirect({ to: "/book", replace: true, statusCode: 301 });
  },
});
